import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../services/api';

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const type = location.state?.type || 'vendor';
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!otp || otp.length !== 6) {
      setError('Please enter the 6-digit code');
      return;
    }
    setLoading(true);
    try {
      if (type === 'customer') {
        await authAPI.customerVerifyOtp({ email, otp });
        setMessage('Email verified! You can now log in.');
      } else {
        await authAPI.verifyOtp({ email, otp });
        setMessage('Email verified! Your account is now under admin review. You will be able to log in once approved.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message
        || 'Verification failed. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError('');
    setMessage('');
    setResending(true);
    try {
      if (type === 'customer') {
        await authAPI.customerResendOtp({ email });
      } else {
        await authAPI.resendOtp({ email });
      }
      setMessage('A new verification code has been sent to your email.');
    } catch (err) {
      setError(
        err.response?.data?.message
        || 'Failed to resend code.'
      );
    } finally {
      setResending(false);
    }
  };

  if (!email) {
    return (
      <div style={{
        minHeight:'100vh',
        background:'var(--bg)',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        color:'var(--text3)',
        fontFamily:'DM Mono,monospace',
      }}>
        <div style={{ textAlign:'center' }}>
          <p>No email found. Please register first.</p>
          <span onClick={() => navigate(type === 'customer' ? '/customer-register' : '/register')}
            style={{ color:'var(--accent)', cursor:'pointer' }}>
            Go to Registration
          </span>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight:'100vh',
      background:'var(--bg)',
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      padding:'20px',
    }}>
      <div style={{ width:'100%', maxWidth:'420px' }}>
        <div style={{ textAlign:'center', marginBottom:'40px' }}>
          <div style={{
            width:'56px', height:'56px',
            background:'var(--accent)',
            borderRadius:'14px',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            fontFamily:'DM Mono,monospace',
            fontSize:'18px', fontWeight:'500',
            color:'var(--bg)',
            margin:'0 auto 16px',
          }}>
            IW
          </div>
          <h1 style={{
            fontFamily:'Syne,sans-serif',
            fontSize:'26px', fontWeight:'800',
            color:'var(--text)',
            marginBottom:'6px',
          }}>
            IRONWALL
          </h1>
          <p style={{
            fontSize:'13px',
            color:'var(--text3)',
            fontFamily:'DM Mono,monospace',
            letterSpacing:'1px',
          }}>
            VERIFY YOUR EMAIL
          </p>
        </div>

        <div style={{
          background:'var(--surface)',
          border:'1px solid var(--border)',
          borderRadius:'16px',
          padding:'32px',
        }}>
          <p style={{
            fontSize:'13.5px',
            color:'var(--text2)',
            marginBottom:'24px',
            textAlign:'center',
          }}>
            We've sent a 6-digit verification code to<br/>
            <strong style={{ color:'var(--text)' }}>{email}</strong>
          </p>

          {!message && (
            <form onSubmit={handleVerify}>
              <div style={{ marginBottom:'20px' }}>
                <label style={{
                  display:'block',
                  fontSize:'11px',
                  fontFamily:'DM Mono,monospace',
                  color:'var(--text3)',
                  letterSpacing:'1px',
                  textTransform:'uppercase',
                  marginBottom:'6px',
                }}>
                  Verification Code
                </label>
                <input
                  value={otp}
                  onChange={e =>
                    setOtp(e.target.value.replace(/\D/g,'').slice(0,6))}
                  placeholder="000000"
                  maxLength={6}
                  style={{
                    width:'100%',
                    background:'var(--surface2)',
                    border:'1px solid var(--border2)',
                    color:'var(--text)',
                    padding:'14px',
                    borderRadius:'8px',
                    fontSize:'24px',
                    letterSpacing:'8px',
                    textAlign:'center',
                    fontFamily:'DM Mono,monospace',
                    outline:'none',
                  }}
                />
              </div>

              {error && (
                <div style={{
                  background:'rgba(255,77,109,0.1)',
                  border:'1px solid rgba(255,77,109,0.3)',
                  color:'var(--red)',
                  padding:'12px 14px',
                  borderRadius:'8px',
                  fontSize:'13px',
                  marginBottom:'16px',
                }}>
                  {error}
                </div>
              )}

              <button type="submit" disabled={loading}
                style={{
                  width:'100%',
                  background: loading ? 'var(--surface3)' : 'var(--accent)',
                  color: loading ? 'var(--text3)' : 'var(--bg)',
                  border:'none',
                  padding:'12px',
                  borderRadius:'8px',
                  fontSize:'14px',
                  fontWeight:'700',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  marginBottom:'16px',
                }}
              >
                {loading ? 'Verifying...' : 'Verify Email →'}
              </button>

              <p style={{
                textAlign:'center',
                fontSize:'13px',
                color:'var(--text3)',
              }}>
                Didn't get the code?{' '}
                <span onClick={handleResend}
                  style={{
                    color: resending ? 'var(--text3)' : 'var(--accent)',
                    cursor: resending ? 'default' : 'pointer',
                  }}>
                  {resending ? 'Sending...' : 'Resend'}
                </span>
              </p>
            </form>
          )}

          {message && (
            <div>
              <div style={{
                background:'rgba(0,229,160,0.1)',
                border:'1px solid rgba(0,229,160,0.3)',
                color:'var(--green)',
                padding:'14px',
                borderRadius:'8px',
                fontSize:'13.5px',
                marginBottom:'20px',
                textAlign:'center',
              }}>
                {message}
              </div>
              <button onClick={() => navigate('/login')}
                style={{
                  width:'100%',
                  background:'var(--accent)',
                  color:'var(--bg)',
                  border:'none',
                  padding:'12px',
                  borderRadius:'8px',
                  fontSize:'14px',
                  fontWeight:'700',
                  cursor:'pointer',
                }}
              >
                Go to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;